import * as React from 'react';

import * as T from '@components/form/Downloader/_downloaderTypes';

const Downloader: React.SFC<T.OutterProps & T.InnerProps> = ({row}) => (
  <a
    href={`/metropolis/api/files/${row.id}`}
    target="_blank"
  >
    {row.name}
  </a>
);

export default Downloader;



// WEBPACK FOOTER //
// ./src/components/form/Downloader/Downloader.tsx